export const setEntryFieldPayload = (fieldData) => {
  return (dispatch, getState) => {
    const currentFields = Array.isArray(getState().entry.fieldPayload) ? getState().entry.fieldPayload : [];

    // Check if the field with the same dataName exists
    const existingFieldIndex = currentFields.findIndex(item => item.dataName === fieldData.dataName);

    let updatedFields;

    if (existingFieldIndex !== -1) {
      // Field exists, update it
      updatedFields = currentFields.map((item, index) => {
        if (index === existingFieldIndex) {
          return { ...item, ...fieldData }; // Update the existing field
        }
        return item; // Return the other fields unchanged
      });
    } else {
      // Field doesn't exist, add it
      updatedFields = [...currentFields, fieldData];
    }

    dispatch({
      type: 'SET_ENTRY_FIELD_PAYLOAD',
      payload: updatedFields,
    });
  };
};
